import { render, staticRenderFns } from "./maskLayer.vue?vue&type=template&id=70e42451&scoped=true"
import script from "./maskLayer.vue?vue&type=script&lang=js"
export * from "./maskLayer.vue?vue&type=script&lang=js"
import style0 from "./maskLayer.vue?vue&type=style&index=0&id=70e42451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e42451",
  null
  
)

export default component.exports